export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "http://localhost:3001",
    backendUrl: "http://localhost:3100",
    jsReportUrl: "http://localhost:5488",
    travelAgentBackendUrl: "http://localhost:3000",
    adminRepoLocation: "http://localhost:3000",
    bookingAppRepoLocation: "http://localhost:3001",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.silverreefdiveresort.com";
    exportResult.backendUrl = "https://sg-api.silverreefdiveresort.com/admin";
    exportResult.jsReportUrl = "https://sg-report.silverreefdiveresort.com";
    exportResult.travelAgentBackendUrl = "https://sg-api.silverreefdiveresort.com/business";
    exportResult.adminRepoLocation = "https://sg-admin.silverreefdiveresort.com";
    exportResult.bookingAppRepoLocation = "https://sg-booking.silverreefdiveresort.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.silverreefdiveresort.com.my";
    exportResult.travelAgentBackendUrl = "https://business-api.travoxis.com";
    exportResult.adminRepoLocation = "https://admin.travoxis.com";
    exportResult.bookingAppRepoLocation = "https://booking.travoxis.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.silverreefdiveresort.com";
    exportResult.backendUrl = "https://api.silverreefdiveresort.com/admin";
    exportResult.jsReportUrl= "https://report.silverreefdiveresort.com";
    exportResult.travelAgentBackendUrl =  "https://api.silverreefdiveresort.com/business";
    exportResult.adminRepoLocation = "https://admin.silverreefdiveresort.com";
    exportResult.bookingAppRepoLocation = "https://booking.silverreefdiveresort.com";
  }
  return exportResult;
};
